import { useEffect, useState } from "react";
import client from "@/lib/api";

// Tiny shared store so every job card heart and the "Saved jobs" filter stay in sync.
let ids = new Set();
let loadedFor = null;
const subs = new Set();
const emit = () => subs.forEach((f) => f(ids));

export function loadSavedJobs(userId) {
  if (!userId) { ids = new Set(); loadedFor = null; emit(); return; }
  if (loadedFor === userId) return;
  loadedFor = userId;
  client.get("/me/saved-jobs").then((r) => { ids = new Set(r.data.ids || []); emit(); }).catch(() => { loadedFor = null; });
}

export async function toggleSavedJob(jobId) {
  const saved = ids.has(jobId);
  ids = new Set(ids);
  saved ? ids.delete(jobId) : ids.add(jobId);
  emit();
  try {
    saved ? await client.delete(`/me/saved-jobs/${encodeURIComponent(jobId)}`) : await client.post(`/me/saved-jobs/${encodeURIComponent(jobId)}`);
    return !saved;
  } catch (e) {
    ids = new Set(ids);
    saved ? ids.add(jobId) : ids.delete(jobId);
    emit();
    throw e;
  }
}

export function useSavedJobs(userId) {
  const [state, setState] = useState(ids);
  useEffect(() => {
    subs.add(setState);
    loadSavedJobs(userId);
    setState(ids);
    return () => { subs.delete(setState); };
  }, [userId]);
  return state;
}
